import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaLinkedinIn, FaTiktok } from 'react-icons/fa';

const SupportPage = () => {
  return (
    <div>
      <section className="privacy-content">
        <div className="container">
          <Link to="/" className="back-link">← Back to Home</Link>

          <h1>Support & Help Center</h1>
          <p><strong>We're here to help you make a difference</strong></p>

          <p>
            Welcome to the Benefit Mankind support center. If you need assistance with our donation app
            or have any questions about our charitable work, you've come to the right place.
          </p>

          <h2>📱 App Support</h2>

          <h3>Getting Started</h3>
          <ul>
            <li><strong>How to download the app:</strong> Search for "Benefit Mankind" in your device's app store</li>
            <li><strong>Creating an account:</strong> Sign up with your email address or phone number</li>
            <li><strong>Making your first donation:</strong> Choose a cause, enter amount, and complete payment securely</li>
            <li><strong>Viewing donation history:</strong> Access your profile to see all past donations</li>
          </ul>

          <h3>Common Issues</h3>

          <div style={{ backgroundColor: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem' }}>
            <h4>Payment Problems</h4>
            <ul>
              <li>Ensure your payment method is valid and has sufficient funds</li>
              <li>Check your internet connection</li>
              <li>Try using a different payment method</li>
              <li>Contact your bank if payments are being declined</li>
            </ul>
          </div>

          <div style={{ backgroundColor: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem' }}>
            <h4>App Crashes or Freezing</h4>
            <ul>
              <li>Close and restart the app</li>
              <li>Update to the latest version from the app store</li>
              <li>Restart your device</li>
              <li>Clear app cache (Android) or offload app (iOS)</li>
            </ul>
          </div>

          <div style={{ backgroundColor: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem' }}>
            <h4>Account Issues</h4>
            <ul>
              <li>Ensure you're using the correct email</li>
              <li>Contact support if account is locked</li>
            </ul>
          </div>

          <h2>💳 Donation Information</h2>

          <h3>Payment Methods</h3>
          <p>We accept the following payment methods:</p>
          <ul>
            <li>Credit and Debit Cards (Visa, Mastercard, American Express)</li>
            <li>Apple Pay (iOS devices)</li>
            <li>Google Pay (Android devices)</li>
          </ul>

          <h3>Donation Security</h3>
          <ul>
            <li>All payments are processed through secure, encrypted channels</li>
            <li>We never store your full payment details</li>
          </ul>

          <h3>Tax Receipts</h3>
          <p>
            All donations are eligible for tax relief in the UK.
          </p>

          <h2>📞 Contact Us</h2>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginTop: '2rem' }}>
            <div style={{ backgroundColor: '#e3f2fd', padding: '2rem', borderRadius: '8px' }}>
              <h3>📧 Email Support</h3>
              <p><strong>General Inquiries:</strong><br />
                <a href="mailto:info@benefitmankind.co.uk">info@benefitmankind.co.uk</a></p>
              <p><strong>Response Time:</strong> Within 24 hours</p>
              <p><strong>Address:</strong><br />
                Benefit Mankind UK Head Office<br />
                Blackburn Enterprise Centre, Suite 01<br />
                Furthergate, Blackburn, BB1 3HQ</p>
            </div>

            <div style={{ backgroundColor: '#e8f5e8', padding: '2rem', borderRadius: '8px' }}>
              <h3>📱 In-App Support</h3>
              <p>Use the "Help & Support" section in the app for:</p>
              <ul>
                <li>Live chat with our support team</li>
                <li>Submit support tickets</li>
                <li>Access FAQ and guides</li>
                <li>Report bugs or issues</li>
              </ul>
            </div>

            <div style={{ backgroundColor: '#fff3e0', padding: '2rem', borderRadius: '8px' }}>
              <h3>📞 Phone Support</h3>
              <p><strong>UK:</strong> +44 (0) 1254 602598</p>
              <p><strong>Hours:</strong> Monday-Friday, 8 AM - 5 PM GMT</p>
              <p><strong>Main Website:</strong> <a href="https://benefitmankind.co.uk" target="_blank" rel="noopener noreferrer">benefitmankind.co.uk</a></p>
            </div>
          </div>

          <h2>🕒 Support Hours</h2>
          <ul>
            <li><strong>Email Support:</strong> 24/7 (response within 24 hours)</li>
            <li><strong>Phone Support:</strong> Monday-Friday, 8 AM - 5 PM GMT</li>
            <li><strong>Live Chat:</strong> Monday-Friday, 9 AM - 8 PM GMT</li>
          </ul>

          <h2>📚 Additional Resources</h2>

          <h3>Helpful Links</h3>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/delete-account">Delete Account</Link></li>
            <li><Link to="/">App Information & Features</Link></li>
            <li><a href="https://benefitmankind.co.uk" target="_blank" rel="noopener noreferrer">Official Website</a></li>
            <li><a href="https://benefitmankind.co.uk/news" target="_blank" rel="noopener noreferrer">Latest News</a></li>
            <li><a href="https://benefitmankind.co.uk/live-feedback" target="_blank" rel="noopener noreferrer">Live Feedback</a></li>
          </ul>

          <h3>Social Media</h3>
          <p>Follow us for updates and impact stories:</p>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginTop: '1rem', justifyContent: 'center' }}>
            <a href="http://fb.me/benefitmankinduk" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                backgroundColor: '#1877f2', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(24, 119, 242, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(24, 119, 242, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(24, 119, 242, 0.3)'; }}>
              <FaFacebookF />
            </a>
            <a href="https://twitter.com/Benefit_Mankind" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                backgroundColor: '#1da1f2', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(29, 161, 242, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(29, 161, 242, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(29, 161, 242, 0.3)'; }}>
              <FaTwitter />
            </a>
            <a href="https://www.instagram.com/benefitmankind/" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(228, 64, 95, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(228, 64, 95, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(228, 64, 95, 0.3)'; }}>
              <FaInstagram />
            </a>
            <a href="https://www.youtube.com/channel/UCH2OM6-bCRyiUWRjfDH1nbA?view_as=subscriber" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                backgroundColor: '#ff0000', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(255, 0, 0, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(255, 0, 0, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(255, 0, 0, 0.3)'; }}>
              <FaYoutube />
            </a>
            <a href="https://uk.linkedin.com/in/benefit-mankind-10317a19b" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                backgroundColor: '#0077b5', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(0, 119, 181, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(0, 119, 181, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(0, 119, 181, 0.3)'; }}>
              <FaLinkedinIn />
            </a>
            <a href="https://www.tiktok.com/@benefitmankind" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                backgroundColor: '#000000', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.3)'; }}>
              <FaTiktok />
            </a>
          </div>

          <div style={{ marginTop: '3rem', padding: '2rem', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <h3>Still Need Help?</h3>
            <p>
              If you can't find the answer you're looking for, don't hesitate to reach out.
              Our support team is dedicated to helping you make a positive impact in the world.
            </p>
            <p style={{ marginTop: '1rem' }}>
              <strong>Quick Contact:</strong> <a href="mailto:info@benefitmankind.co.uk">info@benefitmankind.co.uk</a> | 01254 602598
            </p>
            <p style={{ marginTop: '0.5rem' }}>
              <strong>Visit:</strong> <a href="https://benefitmankind.co.uk" target="_blank" rel="noopener noreferrer">benefitmankind.co.uk</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SupportPage;
